import { Protocol } from 'const';

export const isStartingWithProtocol = (link: string): boolean => {
  return Object.values(Protocol).some(protocol => link.startsWith(protocol));
};
